<template>
  <div class="produce">
    <div class="produce_tab">
      <div
        :class="['produce_tab_item', tabIndex == item.id ? 'line' : '']"
        :data-tab="item.id"
        v-for="item in tabList"
        :key="item.id"
        @click="chooseTab($event)"
      >
        {{ item.tab }}
      </div>
    </div>
    <div class="produce_name">{{ tabList[tabIndex - 1].tab }}介绍</div>
    <div class="produce_tab_brief wow animate__animated animate__slideInRight">
      {{ tabList[tabIndex - 1].brief }}
    </div>

    <div class="introduce">
      <div
        class="introduce_item"
        v-for="(item, index) in tabList[tabIndex - 1]['point']"
        :key="index"
      >
        <img
          v-if="index == 0"
          src="../../static/other/introduce_1.png"
          alt=""
        />
        <img
          v-if="index == 2"
          src="../../static/other/introduce_2.png"
          alt=""
        />
        <img
          v-if="index == 1"
          src="../../static/other/introduce_3.png"
          alt=""
        />
        <div class="introduce_item_title">{{ item.title }}</div>
        <div class="introduce_item_pointDetail">{{ item.pointDetail }}</div>
      </div>
    </div>
    <div class="produce_name" style="margin: 100px 0 30px 0">
      {{ tabList[tabIndex - 1].tab }}产品
      <i
        class="iconfont icon-bangzhu"
        @click="turnTipsSwitch"
        style="color: #ccc; cursor: pointer; font-size: 20px"
      ></i>
    </div>

    <div class="produce_nav">
      <!-- <div class="produce_nav_item">
        <div class="produce_nav_item_title">保函险种:</div>
        <div class="produce_nav_item_con">
          <div  class="kind_item">全部分类</div>
          <div  class="kind_item" v-for="(item, index) in kindOfInsurance" :key="index">
           {{item.kindName}}
          </div>
        </div>
      </div> -->

      <!-- <div class="produce_nav_item">
        <div class="produce_nav_item_title">保函公司:</div>
        <div class="produce_nav_item_con">
          <div class="kind_item active">全部分类</div>
          <div  class="kind_item" v-for="(item, index) in CompanyOfInsurance" :key="index">
            {{item.kindName}}
          </div>
        </div>
      </div> -->
    </div>
    <div class="produce_list">
      <div
        class="produce_list_item"
        v-for="(item, index) in tabList[tabIndex - 1].produce"
        :key="index"
      >
        <div class="produce_list_img">
          <img :src="item.organLogo" alt="" />
          <span v-if="item.id == 1 || item.id == 2 || item.id == 6"
            >出函机构</span
          >
        </div>
        <div class="list_line"></div>
        <div class="produce_list_name">
          <div class="name">
            {{ item.name }}
          </div>
          <div>
            <i
              class="iconfont icon-jiantou_xiangyouliangci"
              style="color: #1a7fd3"
            ></i
            >费率低至{{ item.rate }}
          </div>
          <div>
            <i
              class="iconfont icon-jiantou_xiangyouliangci"
              style="color: #1a7fd3"
            ></i
            >线上投保快捷便利
          </div>
          <div class="tag">
            <i class="iconfont icon-danxuan_xuanzhong1x"></i
            ><span>电子保单</span>
            <i class="iconfont icon-danxuan_xuanzhong1x"></i
            ><span>电子保函</span>
            <i class="iconfont icon-danxuan_xuanzhong1x"></i
            ><span>电子发票</span>
          </div>
          <div class="produce_list_right">
            <!-- <div @click="choose_toast_tab($event)" data-tab="4" style="cursor: pointer;font-size: 14px;">保险条款</div> -->
            <div @click="login(tabIndex)" class="produce_list_btn">
              立即{{
                tabIndex == 1 || tabIndex == 2 || tabIndex == 6
                  ? "投保"
                  : "询价"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toast" v-if="tipsSwitch">
      <div class="toast_con">
        <i
          @click="turnTipsSwitch"
          class="iconfont icon-cuowuguanbiquxiao icon-close"
        ></i>
        <div
          class="toast_con_title"
          @click="choose_toast_tab($event)"
          v-if="!tipsSwitchRe"
        >
          <div
            :class="['toast_tab', toast_tab == 1 ? 'toast_tab_active' : '']"
            data-tab="1"
          >
            投保须知
          </div>
          <div
            :class="['toast_tab', toast_tab == 2 ? 'toast_tab_active' : '']"
            data-tab="2"
          >
            保险责任
          </div>
          <div
            :class="['toast_tab', toast_tab == 3 ? 'toast_tab_active' : '']"
            data-tab="3"
          >
            责任免除
          </div>
        </div>
        <div
          class="toast_con_title"
          @click="choose_toast_tab($event)"
          v-if="tipsSwitchRe"
        >
          <div
            :class="['toast_tab', toast_tab == 4 ? 'toast_tab_active' : '']"
            data-tab="1"
          >
            保险条款
          </div>
        </div>
        <div class="toast_detail">
          <p class="content" v-if="toast_tab == 1">
            1、本平台为企业投保和保险公司承保提供相关信息咨询，投保人支付的保费将直接进入保险公司账户，本平台不收取投保人任何费用。承保、出单、理赔、退保、开具发票等保险业务将由保险公司提供。<br />
            2、通过本平台出具的所有保函产品均由中国银保监会批准设立的金融机构提供，并按照《中华人民共和国保险法》《中华人民共和国招标投标法》等相关法律法规规定要求，承担保险赔偿责任和理赔。<br />
            3、本平台展示的产品由保险公司提供电子保单或纸质保单（无电子保单时采用）。电子保单与纸质保单具有同等的法律效力。<br />
            4、请您于投保项目《招标文件》规定的“投标保证金缴纳截止时间”前完成保费支付，否则投保无效。<br />
            5、请您在投保前务必详细阅读保险条款，特别关注保险责任、责任免除、投保人及被保险人义务、赔偿处理等内容。投保后相关内容发生变动，请及时通知保险公司。<br />
            6、当发生理赔事件时，请根据保单上载明的保险公司电话进行理赔。<br />
            7、本平台仅提供引流服务，保险产品的销售、理赔等服务均由方德保险经纪有限公司提供。<br />
          </p>
          <p class="content" v-if="toast_tab == 2">
            根据《中华人民共和国合同法》和有关法律、法规，以及《建设工程招标文件》、《建设工程施工合同》，在保险期间内，投保人在《建设工程施工合同》的履约过程中，因下列情形之一：<br />
            （一）投标截止后投保人未经被保险人同意或者违反《建设工程招标文件》撤销投标文件；<br />
            （二）投保人与其他投标人相互串通投标；<br />
            （三）投保人弄虚作假行为；<br />
            （四）中标后投保人无正当理由不按《建设工程招标文件》的要求签署《建设工程施工合同》；<br />
            （五）《建设工程招标文件》规定的其他有关投标实质性违约情形；<br />
            给被保险人造成经济损失的，被保险人可向保险人提出索赔，保险人依据本保险合同的约定，在投标保证保险责任范围和保险金额内对被保险人的上述损失承担赔偿责任。<br />
          </p>
          <p class="content" v-if="toast_tab == 3">
            出现下列任一情形时，保险人不承担赔偿保险金的责任：<br />
            （一）投保人与被保险人订立的《建设工程施工合同》或交易基础不成立、不生效、无效、被撤销、被解除的；<br />
            （二）被保险人明知或应该知道投保人违反《建设工程施工合同》约定或法律法规的规定进行转包或违法分包的；<br />
            （三）投保人或其雇员与被保险人或其雇员采用欺诈、恶意串通、贿赂或变相贿赂等手段串通投标、订立《建设工程施工合同》；<br />
            （四)
            投保人或其雇员与被保险人或其雇员恶意串通违反《建设工程施工合同》的约定，损害保险人利益的；<br />
            （五）被保险人未履行《建设工程招标文件》或《建设工程施工合同》条款规定义务的；<br />
            （六）投保人与被保险人变更《建设工程施工合同》、被保险人变更《建设工程招标文件》，未经保险人书面同意确认的。<br />
            下列原因造成的损失、费用和责任，保险人不负责赔偿：<br />
            （一）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动或恐怖袭击；<br />
            （二）核辐射、核爆炸、核污染及其他放射性污染；<br />
            （三）大气污染、土地污染、水污染及其他各种污染；<br />
            （四）政府征用、行政行为或司法行为；<br />
            （五）洪水、台风、地震、海啸等自然灾害。<br />
            下列损失、费用和责任，保险人不负责赔偿：<br />
            （一）被保险人根据《建设工程施工合同》、《建设工程招标文件》应该承担的责任，以及为收集、确认、证明投保人违反《建设工程施工合同》、《建设工程招标文件》约定，造成损失所产生的任何费用；<br />
            （二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动或恐怖袭击；<br />
            （三）被保险人与投保人就《建设工程施工合同》、《建设工程招标文件》产生纠纷所致的任何法律费用，包括但不限于诉讼或仲裁费、财产保全或证据保全费、强制执行费、评估费、拍卖费、鉴定费、律师费、差旅费、调查取证费等；<br />
            （四）因不可抗力导致《建设工程施工合同》无法履行，由投保人和被保险人商定或确定的利益分配、费用承担、损失分担等，以及因此产生的一切损失；<br />
            （五）工程材料供应合同中供应价超过实际供应时点上当地政府相关主管部门指导价（若无指导价，则参考一般市场价）的部分；<br />
            （六）材料供应合同中约定的相关违约金、滞纳金、利息等；<br />
            （七）按本保险合同中载明的免赔率（额）计算的免赔额；<br />
            （八）被保险人以外的第三人的任何损失；<br />
            （九）各类间接损失，包括但不限于延期竣工或延期交付建筑物导致被保险人对于建筑物使用的经济损失或被第三方索赔等；<br />
            （十）被保险人未按照《建设工程施工合同》的约定履行，提前超额支付的工程进度款；<br />
            （十一）罚款、罚金及惩罚性赔偿；<br />
            （十二）精神损害赔偿；<br />
            （十三）不可归责于投保人的情形；<br />
            （十四）其他不属于本保险责任范围内的损失、费用和责任。<br />
          </p>
          <p class="content" v-if="toast_tab == 4">保险公司条款</p>
        </div>
      </div>
    </div>
    <el-dialog width="400px" title="产品咨询" :visible.sync="dialogFormVisible">
      <span style="color: #1a7fd3;margin-bottom: 10px;">请拨打客服电话：400-6399580或19943433777为您定制服务，也可填写您的联系方式，稍后会有客服人员联系您。</span>
      <el-form :model="form">
        <el-form-item label="手机号码:" >

          <el-input v-model="phoneNumber" autocomplete="off"    maxlength="11"  placeholder="请填写手机号码" >
              <template slot="append">
                <span style="cursor: pointer;" v-show="show"  @click="getCode">获取验证码</span>
                <span v-show="!show">{{ count }}秒重发</span>
              </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" >
          <el-input v-model="code" autocomplete="off" placeholder="请填写验证码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '354px', height: '216px' }"
    />
  </div>
</template>

<script>
import {
  saveBusCooperatio,
  sendCheckCode,
  useCheckCode,
} from "../api/basic/index.js";
import { validatePhone, validateTelephone } from "@/utils/validate";
import Verify from "@/components/verifition/Verify.vue"
export default {

  name: "",
  mixins: [],
  components: {
    Verify
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      form:{},
      cooperationArea: "",
      phoneNumber: "",
      dataForm: {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: 1,
      },
      code: "",
      show: true,
      timer: null,
      count: "获取验证码",
      dialogFormVisible:false,
      tabList: [
        {
          tab: "投标保函",
          id: "1",
          brief:
            "投标担保是指由担保人为投标人向招标人提供的，保证投标人按照招标文件的规定参加招标活动的担保。投标人在投标有效期内撤回投标文件，或中标后不签署工程建设合同的，由担保人按照约定履行担保责任。",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "投标担保的有效期应当在保证合同中约定，保证合同的有效期截止时间为投标有效期后的30至180天。由招标人在招标文件中规定或者在工程建设合同中约定，可采用银行保函、专业担保公司保证、定金（保证金）。",
            },

            {
              title: "担保额度",
              pointDetail:
                "担保金额一般为投标总价的2%，最高一般不超过80万人民币。",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
           /* {
              name: "安华招投标保证保险",
              organ: "安华农险",
              organLogo: require("../../static/parter/p-12.png"),
              rate: "0.8%",
            },*/
             {
             name: "投标保证保险",
             organ: "国寿财险",
             organLogo: require("../../static/parter/p-guoshoucai.png"),
             rate: "0.8%",
           },
            {
              name: "投标保证保险",
              organ: "国任保险",
              organLogo: require("../../static/parter/p-15.png"),
              rate: "0.8%",
            },
          ],
        },
          // 合同履约 ：国寿财、阳光
        {
          tab: "合同履约保函",
          id: "2",
          brief:
            "由保证人为承包商向业主提供的保证承包商履行工程建设合同约定义务的担保。",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "承包商履约的有效期应当在保证合同中约定，保证合同约定的有效截止时间为工程建设合同约定的工程竣工验收合格之日后的30天至180天。由招标人在招标文件中规定，可采用银行保函、专业担保公司保证。",
            },

            {
              title: "担保额度",
              pointDetail:
                "承包商履约担保的担保金额一般不低于工程建设合同价格（中标价格）的10%。采用经评审的最低投标价法中标的招标工程，担保金额不得低于工程合同价15%。",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
            {
              name: "合同履约保险",
              organ: "国寿财险",
              organLogo: require("../../static/parter/p-guoshoucai.png"),
              rate: "0.7%",
            },
            {
              name: "合同履约保险",
              organ: "阳光保险",
              organLogo: require("../../static/parter/p-16.png"),
              rate: "0.7%",
            },
          ],
        },
          // 工程预付款：鼎函，可不调整
        {
          tab: "工程款支付保函",
          id: "3",
          brief:
            "由业主方提供给施工方的，是施工方的一种保障，可解决交易双方互不信任的问题",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "担保期限届至建设单位支付除工程质量保修金以外的全部工程结算款项之日后30天。工程款未支付完毕但担保到期的，应延长其有效期或重新办理。 ",
            },

            {
              title: "担保额度",
              pointDetail:
                "担保金额为建设工程合同价款的10%。实施施工过程结算或施工工期超过两年的工程项目可实行分段滚动担保。 ",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
            {
              name: "工程款支付保函",
              organ: "鼎函网",
              organLogo: require("../assets/dinghan-logo-3.jpg"),
              rate: "1%",
            },
          ],
        },
          // 预付款保函：阳光、鼎函
        {
          tab: "预付款保函",
          id: "4",
          brief:
            "业主支付给承包人或供应商合同约定的预付款时， 由承包人或供应商向业主提交的担保，保证其按照合同约定正确和合理地为合同目的使用预付款， 以及按合同约定配合业主全额扣回所预付的金额， 不将预付款挪作他用。",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "由业主与承包人或供应商协商确定，预付款保证担保的有效期最长不超过预付款全额返还或抵扣之日后30天。银行保函、专业担保公司保证。",
            },

            {
              title: "担保额度",
              pointDetail:
                "预付款的担保金额由业主与承包商协商确定，一般为工程建设合同价格（中标价格）的5%-30%。",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
            {
              name: "预付款保证保函",
              organ: "阳光保险",
              organLogo: require("../../static/parter/p-16.png"),
              rate: "1%",
            },
            {
              name: "预付款保证保函",
              organ: "鼎函网",
              organLogo: require("../assets/dinghan-logo-3.jpg"),
              rate: "1%",
            },
          ],
        },
          // 工程质量保函：国寿财、阳光、鼎函
        {
          tab: "工程质量保函",
          id: "5",
          brief:
            "由担保人为承包商向业主提供的，保证承包商在工程质量保修担保期内承担质量保修责任的担保",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "由业主与承包商根据《建设工程质量管理条例》第四十条相关规定在合同中共同约定。银行保函、专业担保公司保证。",
            },

            {
              title: "担保额度",
              pointDetail:
                "由业主与承包商在合同中约定，一般不应超过工程合同总造价的5%。",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
            {
              name: "工程质量保证保函",
              organ: "国寿财险",
              organLogo: require("../../static/parter/p-guoshoucai.png"),
              rate: "1.5%",
            },
            {
              name: "工程质量保证保函",
              organ: "阳光保险",
              organLogo: require("../../static/parter/p-16.png"),
              rate: "1.5%",
            }
          ],
        },
          // 农民工工资保函：紫金、鼎函
        {
          tab: "农民工工资支付保函",
          id: "6",
          brief:
            "是指担保人对业主或承包商支付工人工资义务的担保。一旦业主或承包商违约，不能按时、足额支付工人工资，担保人将代为支付(之后担保人再向业主或承包商追偿)，以保障工人的合法权益。",
          point: [
            {
              title: "担保期限&方式",
              pointDetail:
                "根据工程施工合同期限而定，一般不超过三年。银行保函、专业担保公司保证。",
            },
            {
              title: "担保额度",
              pointDetail:
                "根据全国不同省、市、地区的人力资源社会保障行政部门、行业主管部门对农民工工资支付保证金监管政策所对应的缴存比例而定，一般业主或承包商单方不会超过3%。",
            },
            {
              title: "产品优势",
              pointDetail:
                "减少缴纳现金保证金引起的资金占用，获得资金收益；与缴纳现金保证金相比，可使有限的资金得到优化配置，全程电子保函操作，提高办事效率",
            },
          ],
          produce: [
            {
              name: "农民工工资支付保险",
              organ: "紫金",
              organLogo: require("../../static/parter/p-10.png"),
              rate: "1%",
            },
            {
              name: "农民工工资支付保险",
              organ: "鼎函网",
              organLogo: require("../assets/dinghan-logo-3.jpg"),
              rate: "1%",
            }
          ],
        },
      ],
      kindOfInsurance: [
        { id: 1, kindName: "工程投标" },
        { id: 2, kindName: "农民工" },
        { id: 3, kindName: "预付款" },
        { id: 4, kindName: "合同履约" },
        { id: 5, kindName: "工程质量" },
        { id: 6, kindName: "业主支付" },
      ],
      CompanyOfInsurance: [
        { id: 1, kindName: "阳光产险" },
        { id: 2, kindName: "长安保险" },
        { id: 3, kindName: "天安财险" },
        { id: 4, kindName: "亚太财险" },
        { id: 5, kindName: "国任保险" },
        { id: 6, kindName: "中国人寿财险" },
        { id: 7, kindName: "阳光信保" },
        { id: 8, kindName: "阳光信保" },
      ],

      tabIndex: 1,
      toast_tab: 1,
      tipsSwitch: false,
      tipsSwitchRe: false,
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function (val) {
        this.tabIndex = val.query.tabIndex;
        document.documentElement.scrollTop = 100;
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let tabIndex = this.$route.query.tabIndex;
    if (tabIndex) {
      this.tabIndex = tabIndex;
      document.documentElement.scrollTop = 100;
    }
  },
  updated() {},
  mounted() {},
  methods: {
    chooseTab(e) {
      let tabIndex = e.target.dataset.tab;
      this.tabIndex = tabIndex;
      document.documentElement.scrollTop = 100;
    },
    login(id) {
      if (id == 1 || id == 2 || id == 6) {
        window.open("https://tb.dinghanwang.com/login");
      } else {
        // this.$alert("请拨打客服电话：400-6399580为您定制服务。", "", {
        //   confirmButtonText: "确定",
        // });
        this.dialogFormVisible = true
      }
    },
    choose_toast_tab(e) {
      let tabIndex = e.target.dataset.tab;
      this.toast_tab = tabIndex;
      if (this.toast_tab == 4) {
        this.turnTipsSwitch();
        this.tipsSwitchRe = true;
      }
    },
    turnTipsSwitch() {
      this.tipsSwitch = !this.tipsSwitch;
      if (!this.tipsSwitch) {
        this.tipsSwitchRe = false;
        this.toast_tab = 1;
      }
    },
    getCode() {
      console.log(Number(this.tabIndex)+1)
      if (!this.phoneNumber) {
        this.$message.error("请先输入手机号");
        return;
      }
      if (
        (!validatePhone(this.phoneNumber) &&
          !validateTelephone(this.phoneNumber)) ||
        this.phoneNumber.length != 11
      ) {
        this.$message({
          title: "提示",
          message: "请输入正确的联系电话",
          type: "warning",
        });
      } else {
        //查询是否进行行为认证
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.getVerifyCode();
      const params = {
        phone: this.phoneNumber,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    getVerifyCode() {
      this.show = false;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submit() {
      if (
        this.phoneNumber  && this.code
      ) {
        const phoneParams = {
          phone: this.phoneNumber,
          businessCode: 'globalTemplate',
          checkCode: this.code
        };
        useCheckCode(phoneParams).then((phoneRes) => {
          if (phoneRes.data.resultCode == '200') {
            this.saveBusCooperatio()
          }

        });
      } else {
        this.$message.error("请按照页面信息填写完整");
      }
    },
    saveBusCooperatio(){
      this.dataForm.phoneNumber = this.phoneNumber
      this.dataForm.cooperationArea = this.cooperationArea
      this.dataForm.businessType = Number(this.tabIndex)+1
      console.log('!!@@@',this.dataForm.businessType)
      saveBusCooperatio(this.dataForm).then((res) => {
            if(res.data.resultCode == '200') {
              this.$message({
                message: '提交成功！稍后会有客服人员联系您。',
                type: 'success'
            });
            this.dialogFormVisible = false
            }
          });
    }
  },
};
</script>

<style scoped >
.produce {
  width: 1400px;
  margin: auto;
  /* background: rgb(243, 245, 245); */
  padding: 10px;
}
.produce_tab {
  display: flex;
  justify-content: center;
  align-items: center;
}
.produce_tab_con {
  min-height: 550px;
}
.produce_img {
  width: 100%;
  min-height: 10px;
}
.produce_img > img {
  width: 1280px;
  height: 780px;
  margin: auto;
}
.produce_tab_item {
  width: 100px;
  flex-grow: 1;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}
.line {
  border-bottom: 3px solid rgb(26, 127, 221);
  color: #1a7fd3;
}
.produce_tab_point {
  /* display: flex;
    justify-content: space-between; */
}
.point_item {
  /* width:360px ;
    height: 400px;
    background: rgb(26, 127, 221);
    color: #fff;
    padding: 10px;
    box-sizing: border-box; */
}
.title {
  font-size: 30px;
  margin-bottom: 50px;
}
.content {
  line-height: 30px;
  overflow: hidden;
}
.produce_name {
  border-left: 5px solid rgb(26, 127, 221);
  font-size: 30px;
  color: rgb(26, 127, 221);
  padding-left: 10px;
  height: 20px;
  line-height: 20px;
  margin: 30px 0;
}
.produce_tab_brief {
  margin: 0 0 30px 0;
  min-height: 60px;
}

.business_con {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
}
.btn {
  width: 150px;
  height: 45px;
  background: rgb(26, 127, 221);
  color: #fff;
  text-align: center;
  line-height: 45px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 100px auto;
  border-radius: 5px;
  cursor: pointer;
}
.produce_nav {
  width: 100%;
  /* min-height: 200px; */
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.produce_nav_item {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.produce_nav_item_title {
  width: 100px;
  text-align: right;
  margin-right: 20px;
}
.produce_nav_item_con {
  width: calc(100% - 120px);
  display: flex;
  flex-wrap: wrap;
}
.kind_item {
  padding: 0 8px;
  line-height: 30px;
  border-radius: 20px;
  border: 1px solid #c1c1c1;
  margin-right: 15px;
  margin-bottom: 20px;
  cursor: pointer;
  color: #797979;
}
.active {
  border: 1px solid rgb(26, 127, 221);
  color: rgb(255, 255, 255);
  background: #79b0e9;
}
.produce_list {
  margin: 10px 0 100px 0;
  min-height: 100px;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  /* gap: 20px; */
}
.produce_list_item {
  width: 560px;
  height: 330px;
  padding: 50px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 30px;
}
.produce_list_img {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.produce_list_img span {
  color: #7d7d7d;
}
.produce_list_name {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.produce_list_name .name {
  max-height: 50px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.produce_list_name .tag {
  margin-top: 30px;
}
.produce_list_name .tag i {
  color: #1a7fd3;
  /* margin-left: 10px; */
}
.produce_list_name .tag span {
  margin-right: 8px;
}
.produce_list_right {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  color: #595959;
  position: absolute;
  right: 0px;
  bottom: -30px;
}
.produce_list_btn {
  width: 96px;
  height: 40px;
  background: #1a7fd3;
  color: #fff;
  text-align: center;
  font-size: 16px;
  border-radius: 5px;
  line-height: 40px;
  margin-top: 10px;
  cursor: pointer;
}
.list_line {
  width: 1px;
  height: 250px;
  background: #f2f1f1;
  margin: 0 10px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
}

/* 介绍 */
.introduce {
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
.introduce_item {
  width: 25%;
  height: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  color: #f5f5f5;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  background-image: linear-gradient(
    to top right,
    rgb(40, 123, 225),
    rgb(79, 181, 221)
  );
}
.introduce_item img {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 20px;
  left: 30px;
}

.introduce_item_title {
  font-size: 24px;
  text-align: right;
  margin: 30px 10px;
}
.introduce_item_pointDetail {
  margin-top: 44px;
}
.toast {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  animation: fadeIn;
  animation-duration: 0.5s;
}
.toast_con {
  background: #fff;
  width: 600px;
  height: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
}
.toast_detail {
  height: calc(100% - 60px);
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: #cacaca;
}
.toast_con_title {
  display: flex;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.toast_tab {
  flex: 1;
  cursor: pointer;
  border-bottom: 2px solid #d5d5d5;
}
.toast_tab_active {
  border-bottom: 2px solid #1a7fd3;
}
.toast_detail {
  padding: 20px 10px;
  box-sizing: border-box;
}
.icon-close {
  font-size: 18px;
  position: absolute;
  right: 2px;
  top: 2px;
  color: #c1c1c1;
  cursor: pointer;
}
</style>

